module.exports = __webpack_public_path__ + "img/13.6.CODm.ff742fcd.png";